import { WheelchairOrStrecherDetailEntity } from '../entities/WheelchairOrStrecherDetail.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getWheelchairOrStrecherDetails(
    abortSignal: AbortSignal,
): Promise<Array<WheelchairOrStrecherDetailEntity>> {
    return apiGet<Array<WheelchairOrStrecherDetailEntity>>('/wheelchair-or-strecher-detail', abortSignal);
}
